import { detectOverflow, Modifier } from "@popperjs/core";
import { Options as DetectOverflowOptions } from "@popperjs/core/lib/utils/detectOverflow";

export interface CheckMaxHeightModifierData {
    height: number;
}

export const hasCheckMaxHeightModifierData = (obj: unknown): obj is CheckMaxHeightModifierData => {
    return obj !== null && typeof obj === "object" && Object.hasOwnProperty.call(obj, "height");
};

export const checkMaxHeightModifier: Modifier<"checkMaxHeight", DetectOverflowOptions> = {
    name: "checkMaxHeight" as const,
    enabled: true,
    phase: "main",
    requiresIfExists: ["offset", "preventOverflow", "flip"],
    fn({ state, name, options }) {
        const overflow = detectOverflow(state, options);
        const { y } = state.modifiersData.preventOverflow || {
            x: 0,
            y: 0,
        };
        const { height } = state.rects.popper;
        const [basePlacement] = state.placement.split("-");

        const heightProp = basePlacement === "top" ? "top" : "bottom";

        state.modifiersData[name] = {
            height: height - overflow[heightProp] - y,
        };
    },
};
